export const ProjectTypes= {
    REACTJS :"React JS",
    REACTNATVIVE:"React Native",
    SVELTEJS:"Svelte JS",
    XAMARIN:"Xamarin",
    ASPNETCORE: "ASP.NET Core",
    VUEJS: "Vue JS",
}